/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgImportExport = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="m8 2 5.707 5.707-1.414 1.414L9 5.828V14H7V5.826L3.707 9.121 2.293 7.707zm8 20 5.707-5.707-1.414-1.414L17 18.172V10h-2v8.174l-3.293-3.295-1.414 1.414z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgImportExport as ImportExport };
